import { useTranslation } from 'react-i18next';

import { LinkButton } from '../../LinkButton/LinkButton';

import type { FC } from 'react';

interface SeeMoreButtonProps {
  url: string;
  onClick?: () => void;
}

const SeeMoreButton: FC<SeeMoreButtonProps> = ({ url, onClick }) => {
  const { t } = useTranslation();
  return (
    <LinkButton
      url={url}
      variant="outlined"
      size="large"
      rounded
      onClick={() => {
        if (onClick) {
          onClick();
        }
      }}
    >
      {t('See more')}
    </LinkButton>
  );
};

export { SeeMoreButton };
